<gstar-general-rates-rule-engine-grid
  #grid
  [source]="items()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)"
  (deleteRequested)="onDeleteRequested($event)"
  (selectRows)="onItemsSelected($event)" />
